<template>
  <div class="popup-info popup-icon-info">
      <svg style="height: 48px;">
        <use xlink:href="@/assets/img/big-icons-sprite.svg#error-upload"></use>
      </svg>

      <div class="text mt24">
          <div class="text-size-l text-bold info-title text-color-red2" >Ошибка загрузки</div>

          <p class="info-text mt16">
              Допускаются файлы в формате <br>
              JPG, PNG, SVG<br>
              весом не более 30Мб.
          </p>
      </div>

      <div class="mt24">
          <button class="btn" @click="close">Понятно</button>
      </div>
  </div>
</template>

<script>
    import {mapState} from 'vuex';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue'

    export default {
        name: "ErrorUploadScheme",
        components: {
            SubmitBtn
        },
        data() {
            return {
                btnType: 'normal',
            }
        },
        props: {
        },
        methods: {
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.errorSchemeUpload.name});
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                item: state => state.rules.editItem,
                topSections: state => state.rules.topSections,
            }),
            activeTopSection(){
                if(this.isSearch) return false;
                return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
            },
        }
    }
</script>

<style scoped>

</style>
